import React from "react";
import * as Yup from "yup";
import { Grid, Button, Box, Paper, Typography, Chip, Divider, CircularProgress } from "@mui/material";
import { Download, Print, Visibility, CheckCircle, LocalShipping, Phone, CalendarToday, Person, Settings } from "@mui/icons-material";
// project imports
import MainCard from "../../ui-component/cards/MainCard";
import { Formik } from "formik";
import FormField from "../../ui-component/CustomTextField";
import { uploadReceiptInitials, uploadReceiptFormFields } from "../../formjson/uploadReceipt";
import { useState, useEffect, useRef } from "react";
import TaggingService from "../../services/TaggingService";
import { fetchTaggedList } from "../../helper";
import { useTranslation } from 'react-i18next';
import { jsPDF } from "jspdf";
import mapwalLogo from "../../assets/images/logo.png";

const formatICCID = (val) => {
  if (!val) return "";
  const str = String(val);
  if (str.toLowerCase().includes('e')) {
    try {
      return Number(val).toLocaleString('en-US', { useGrouping: false });
    } catch (e) {
      return str;
    }
  }
  return str;
};

const UploadReceipt = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [updatedFormFields, setUpdatedFormField] = useState(uploadReceiptFormFields);
  const [isFormLoaded, setIsFormLoaded] = useState(false);
  const [certificateData, setCertificateData] = useState(null);
  const certificateRef = useRef(null);

  useEffect(() => {
    (async () => {
      const filter = {
        is_tagged: "True",
      }
      const tagged_list = await fetchTaggedList(filter);
      setUpdatedFormField((prevConfig) => ({
        ...prevConfig,
        device_id: {
          ...prevConfig.device_id,
          options: tagged_list,
        },
      }));
      setIsFormLoaded(true);
    })();
  }, []);

  const handleFileChange = (event, formik) => {
    const selectedFile = event.target.files[0];
    const fieldName = event.target.name;
    if (selectedFile) {
      formik.setFieldValue(fieldName, selectedFile);
    }
  };

  const validationSchema = Yup.object(
    Object.keys(updatedFormFields).reduce((acc, field) => {
      acc[field] = updatedFormFields[field].validation;
      return acc;
    }, {})
  );

  // ==========================================
  // FETCH INVOICE USING IMEI
  // ==========================================
  const loadInvoice = async (values) => {
    try {
      setLoading(true);

      const response = await TaggingService.getDeviceTagInvoice({
        q: values.device_id
      });

      const row = response?.data?.results?.results?.[0];

      if (!row) {
        alert("Invoice not found.");
        return;
      }

      setInvoiceData(row);

    } catch (error) {
      console.log(error);
      alert("Failed to fetch invoice.");
    } finally {
      setLoading(false);
    }
  };


  // const handleDownloadPdf = async () => {
  //   if (!certificateData) {
  //     alert("Please view the certificate first by clicking 'View Certificate'.");
  //     return;
  //   }

  //   const pdf = new jsPDF();
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();

  //   const img = new Image();
  //   img.src = mapwalLogo;

  //   const generatePdf = () => {
  //     try {
  //       const margin = 10;
  //       const imgWidth = pageWidth - margin * 2;
  //       const imgHeight = (img.height * imgWidth) / img.width;

  //       try {
  //         pdf.addImage(img, "PNG", margin, (pageHeight - imgHeight) / 2, imgWidth, imgHeight, undefined, "FAST");
  //       } catch (e) {
  //       }

  //       pdf.setFontSize(18);
  //       pdf.text("ASSAM STATE VLTD BACKEND", pageWidth / 2, 30, { align: "center" });
  //       pdf.setFontSize(14);
  //       pdf.text("VLTD TAGGING & ACTIVATION CERTIFICATE", pageWidth / 2, 42, { align: "center" });

  //       pdf.setFontSize(12);
  //       let y = 60;
  //       const fields = [
  //         { label: "VLTD Tagging & Activation Date", value: certificateData.taggingActivationDate },
  //         { label: "Vehicle Owner Name", value: certificateData.vehicleOwnerName },
  //         { label: "Vehicle Registration Number", value: certificateData.vehicleRegNo },
  //         { label: "Engine Number", value: certificateData.engineNo },
  //         { label: "Chassis Number", value: certificateData.chassisNo },
  //         { label: "Vehicle Model", value: certificateData.vehicleModel },
  //         { label: "Vehicle Category", value: certificateData.vehicleCategory },
  //         { label: "VLTD Make", value: certificateData.vltdMake },
  //         { label: "VLTD Model", value: certificateData.vltdModel },
  //         { label: "VLTD IMEI Number", value: certificateData.vltdImei },
  //         { label: "eSIM ICCID Number", value: certificateData.esimIccid },
  //         { label: "eSIM ICCID Number 2", value: certificateData.esimIccid2 },
  //         { label: "eSIM Validity", value: certificateData.esimValidity },
  //       ];

  //       fields.forEach((field) => {
  //         pdf.text(`${field.label}: ${field.value || "__________"}`, 20, y);
  //         y += 10;
  //       });

  //       y += 10;
  //       pdf.setFontSize(10);
  //       pdf.text("Note:", 20, y);
  //       y += 8;
  //       const note = "This certificate is system-generated from the SkyTron platform and does not require any physical signature or stamp.";
  //       const lines = pdf.splitTextToSize(note, pageWidth - 40);
  //       lines.forEach((line) => {
  //         pdf.text(line, 20, y);
  //         y += 6;
  //       });

  //       y += 12;
  //       pdf.text("**********************", pageWidth / 2, y, { align: "center" });

  //       pdf.save("VLTD_Tagging_Activation_Certificate.pdf");
  //     } catch (error) {
  //       pdf.save("VLTD_Tagging_Activation_Certificate.pdf");
  //     }
  //   };

  //   if (img.complete) {
  //     generatePdf();
  //   } else {
  //     img.onload = generatePdf;
  //     img.onerror = generatePdf;
  //   }
  // };

 const generateInvoice = (invoiceData) => {
     const doc = new jsPDF("p", "mm", "a4");
     const pageWidth = 210;
     const pageHeight = 297;
     const dealer = invoiceData?.dealer || "";
     const customer = invoiceData?.customer || "";
     const customerGstin = invoiceData?.customer_gstin || "";
     const dealerGstn = invoiceData?.dealer_gstn || "";
     const dealerAddress = invoiceData?.dealer_address || "";
     const dealerState = invoiceData?.dealer_state || "";
     const ownerMobile = invoiceData?.owner_mobile_no || "";
     const vehicleRegNo = invoiceData?.vehicle_reg_no || "";
     const chassisNo = invoiceData?.chassis_no || "";
     const bankName =
  invoiceData?.bank_name ||
  process.env.REACT_APP_BANK_NAME ||
  "";

const accountName =
  invoiceData?.account_name ||
  process.env.REACT_APP_ACCOUNT_NAME ||
  "";

const accountNo =
  invoiceData?.account_number ||
  process.env.REACT_APP_ACCOUNT_NUMBER ||
  "";

const ifscCode =
  invoiceData?.ifsc_code ||
  process.env.REACT_APP_IFSC_CODE ||
  "";

const branch =
  invoiceData?.branch ||
  process.env.REACT_APP_BRANCH ||
  "";
 
     const today =
       invoiceData?.invoice_date || new Date().toLocaleDateString("en-GB");
 
     const taxable = Number(invoiceData?.net_amount || 0);
     const cgst = Number(invoiceData?.cgst_9_percent || 0);
     const sgst = Number(invoiceData?.sgst_9_percent || 0);
     const igst = Number(invoiceData?.igst_18_percent || 0);
     const total = Number(invoiceData?.gross_amount || 0);
 const vehicleMake = invoiceData?.vehicle_make || "";
 const vehicleModel = invoiceData?.vehicle_model || "";
 const imeiNo = invoiceData?.device_imei_no || "";
 const customerAddress = invoiceData?.customer_address || "";
 const ownerState = invoiceData?.owner_state || "";

const dealerStateId = Number(invoiceData?.dealer_state_id);
const ownerStateId = Number(invoiceData?.owner_state_id);

// Dealer State != Owner State => IGST
const isIGST = dealerStateId !== ownerStateId;
     // ===============================
     // HELPERS
     // ===============================
     const txt = (t, x, y, size = 10, style = "normal", color = [0, 0, 0]) => {
       doc.setFont("times", style);
       doc.setFontSize(size);
       doc.setTextColor(...color);
       doc.text(String(t), x, y);
     };
 
 
     const line = (x1, y1, x2, y2) => doc.line(x1, y1, x2, y2);
 
 
     // ===============================
     // TITLE
     // ===============================
     doc.rect(5, 5, 200, 13);
 
 doc.setFont("times", "bold");
 doc.setFontSize(16);
 doc.text("Tax Invoice", 105, 13, { align: "center" });
 
 
     // TOP BOX
 doc.rect(5, 18, 200, 95);
 
 // 50% | 25% | 25%
 const leftCol = 105; // 5 + 100
 const midCol = 155;  // 105 + 50
 
 line(leftCol, 18, leftCol, 113);
 line(midCol, 18, midCol, 113);
 
 // Horizontal lines for center + right sections
 line(leftCol, 38, 205, 38);
 line(leftCol, 58, 205, 58);
 line(leftCol, 78, 205, 78);
 
     // LEFT SELLER
 txt("Seller", 7, 24, 14);
 
 txt(dealer, 7, 31, 12, "bold");
 txt(`Address: ${dealerAddress}`, 7, 38, 12);
 txt(`GSTIN: ${dealerGstn}`, 7, 45, 12);
 txt(`State : ${dealerState}`, 7, 52, 12);

 // Seller / Buyer Divider
 line(5, 63, 105, 63);
 
 txt("Buyer", 7, 72, 14);
 
 txt(customer, 7, 80, 12, "bold");
 txt(`Address: ${customerAddress}`, 7, 88, 12);
 txt(`State :${ownerState}`, 7, 96, 12);
 txt(`GSTIN : ${customerGstin}`, 7, 104, 12);
 txt(`Mobile No: ${ownerMobile}`, 7, 112, 12);
     // CENTER COLUMN
 txt("Invoice No.", 110, 25, 14, "bold");
 const invoiceNo = invoiceData?.bill_no || "";
 txt(invoiceNo, 110, 33, 12);
 
 txt("Supplier Reference", 110, 45, 14, "bold");
 txt(invoiceData?.device_imei_no || "", 110, 53, 12);
 
 txt("Registration No", 110, 65, 14, "bold");
 txt(vehicleRegNo, 110, 73, 12);
 
 txt("Date", 160, 25, 14, "bold");
 txt(today, 160, 33, 12);
 
 txt("Chassis No", 160, 45, 14, "bold");
 txt(chassisNo, 160, 53, 12);
 
 txt("Quantity", 160, 65, 14, "bold");
 txt("1 Pcs", 160, 73, 12);
 
     // ===============================
     // PRODUCT TABLE
     // ===============================
 
 doc.rect(5, 113, 200, 84);
 
 const cols = [
   5,    // SL
   18,   // Description
   98,   // HSN
   116,  // GST
   128,  // Qty (reduced)
   148, // Rate start
   174, // Per start
   184, // Amount start
   205
 ];
 
 cols.forEach((x) => line(x, 113, x, 197));
 
 // horizontal lines
 line(5, 123, 205, 123); // header
 
 line(5, 165, 205, 165); // item section
 line(5, 173, 205, 173); // discount
//  line(5, 181, 205, 181); // cgst
//  line(5, 189, 205, 189); // sgst
//  line(5, 197, 205, 197); // igst
 if (isIGST) {
  line(5, 197, 205, 197); // igst
  } else {
    line(5, 181, 205, 181); // cgst
 line(5, 189, 205, 189); // sgst
  }
 // Headers
 txt("SL", 9, 120, 11);
 txt("Description of Goods", 22, 120, 11);
 
 txt("HSN", 102, 120, 11);
 txt("GST", 120, 120, 11);
 txt("Qty", 132, 120, 11);
 txt("Rate", 154, 120, 11);
 txt("Per", 176, 120, 11);
 txt("Amount", 190, 120, 11);
 
 // Product row
 txt("1", 9, 136, 12);
 
 txt("Vehicle Location Tracking Device", 22, 136, 12, "bold");
 
 txt("Make : Mapwala", 22, 145, 12);
 txt("Model : Mapwala T600", 22, 153, 12);
 
 txt(`IMEI : ${imeiNo}`, 22, 161, 11, "bold");
 txt("852691", 102, 144, 12);
 txt("18%", 120, 144, 12);
 txt("1 Pcs", 131, 144, 12);
 
 doc.setFont("times", "bold");
 doc.setFontSize(11);
 
 // Rate column (152-170)
 doc.text(
   taxable.toFixed(2),
   168,
   144,
   { align: "right" }
 );
 
 // Per column (170-182)
 doc.setFont("times", "normal");
 doc.setFontSize(10);
 
 doc.text(
   "Pcs",
   179,
   144,
   { align: "center" }
 );
 
 // Amount column (182-205)
 doc.setFont("times", "bold");
 doc.text(
   taxable.toFixed(2),
   203,
   144,
   { align: "right" }
 );
 
 // Discount Row
 txt("Discount", 22, 169, 12);
 if (isIGST) {
  txt("IGST", 102, 178, 12);
  txt("18%", 120, 178, 12);
  txt(igst.toFixed(2), 187, 178, 12, "bold");
} else {
  txt("CGST", 102, 178, 12);
  txt("9%", 120, 178, 12);
  txt(cgst.toFixed(2), 187, 178, 12, "bold");

  txt("SGST", 102, 186, 12);
  txt("9%", 120, 186, 12);
  txt(sgst.toFixed(2), 187, 186, 12, "bold");
}
 // TOTAL ROW
 // TOTAL ROW
 doc.rect(5, 197, 200, 10);
 
 // Qty column
 line(128, 197, 128, 207);
 
 // Amount column (same as table above)
 line(184, 197, 184, 207);
 
 txt("Total", 22, 204, 11, "bold");
 txt("1 Pcs", 132, 204, 12);
 
 doc.setFont("times", "bold");
 doc.text(
   total.toFixed(2),
   203,
   204,
   { align: "right" }
 );
     // ===============================
     // AMOUNT WORDS
     // ===============================
     const numberToWords = (num) => {
       const a = [
         "", "One", "Two", "Three", "Four", "Five",
         "Six", "Seven", "Eight", "Nine", "Ten",
         "Eleven", "Twelve", "Thirteen", "Fourteen",
         "Fifteen", "Sixteen", "Seventeen", "Eighteen",
         "Nineteen"
       ];
 
       const b = [
         "", "", "Twenty", "Thirty", "Forty",
         "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
       ];
 
       const inWords = (n) => {
         if (n < 20) return a[n];
         if (n < 100)
           return b[Math.floor(n / 10)] + " " + a[n % 10];
         if (n < 1000)
           return (
             a[Math.floor(n / 100)] +
             " Hundred " +
             inWords(n % 100)
           );
         return (
           inWords(Math.floor(n / 1000)) +
           " Thousand " +
           inWords(n % 1000)
         );
       };
 
       return inWords(num);
     };
 // Amount words section (keep same height)
 doc.rect(5, 207, 200, 18);
 
 txt("Amount Chargeable (in words)", 7, 214, 12);
 
 txt(
   `${numberToWords(Math.round(total))} Only`,
   7,
   221,
   12,
   "bold"
 );
 
 // ===============================
 // BANK DETAILS
 // ===============================
 
 doc.rect(5, 225, 200, 30);
 
 txt("Seller Bank Details", 10, 233, 12, "bold");
 
 txt(`Name : ${accountName}`, 10, 240, 11);
 txt(`A/c No : ${accountNo}`, 10, 246, 11);
 txt(`Bank : ${bankName}`, 10, 251, 11);
 
 txt(`Branch : ${branch}`, 110, 240, 11);
 txt(`IFSC : ${ifscCode}`, 110, 246, 11);
 
 // ===============================
 // DECLARATION + AUTHORISED SIGN
 // ===============================
 
 doc.rect(5, 255, 200, 20);
 line(140, 255, 140, 275);
 
 txt("Declaration:", 8, 262, 12, "bold");
 
 txt(
   "We declare that this invoice shows the actual",
   8,
   267,
   11
 );
 
 txt(
   "price of the goods described and particulars are correct.",
   8,
   272,
   11
 );
 
 doc.setFont("times", "bold");
 doc.setFontSize(12);
 
 doc.text(
   "Authorised Signatory",
   172.5,
   270,
   { align: "center" }
 );
 
 // ===============================
 // COMPUTER GENERATED INVOICE
 // =================//
 
 
 // Center aligned text
 doc.setFont("times", "italic");
 doc.setFontSize(12);
 
 doc.text(
   "This is a Computer Generated Invoice",
   pageWidth / 2,
   287,
   { align: "center" }
 );
     // ===============================
     // OPEN + DOWNLOAD
     // ===============================
     return doc;
   };

//  const handleDownloadPdf = () => {
//   if (!invoiceData) return;

//   const content =
//     document.getElementById("invoice-print-area").innerHTML;

//   const iframe = document.createElement("iframe");
//   iframe.style.position = "fixed";
//   iframe.style.right = "0";
//   iframe.style.bottom = "0";
//   iframe.style.width = "0";
//   iframe.style.height = "0";
//   iframe.style.border = "0";

//   document.body.appendChild(iframe);

//   const doc =
//     iframe.contentWindow.document ||
//     iframe.contentDocument;

//   doc.open();
//   doc.write(`
//     <html>
//       <head>
//         <title>Invoice_${invoiceData.invoice_no}</title>

//         <style>
//           body{
//             margin:0;
//             padding:20px;
//             font-family:"Times New Roman", serif;
//             font-size:12px;
//             color:#000;
//           }

//           table{
//             width:100%;
//             border-collapse:collapse;
//             table-layout:fixed;
//           }

//           table, td, th{
//             border:1px solid #000;
//           }

//           td, th{
//             padding:4px;
//             vertical-align:top;
//           }

//           span{
//             color:red !important;
//             font-weight:bold;
//           }

//           @page{
//             size:A4 portrait;
//             margin:10mm;
//           }
//         </style>
//       </head>

//       <body>
//         ${content}
//       </body>
//     </html>
//   `);

//   doc.close();

//   setTimeout(() => {
//     iframe.contentWindow.focus();
//     iframe.contentWindow.print();

//     setTimeout(() => {
//       document.body.removeChild(iframe);
//     }, 1500);
//   }, 500);
// };

  // ==========================================
  // PRINT
  // ==========================================


   const handleDownloadPdf = () => {
  if (!invoiceData) return;

  const doc = generateInvoice(invoiceData);

  doc.save(
    `Invoice_${invoiceData.vehicle_reg_no || "invoice"}.pdf`
  );
};

// const handlePrint = () => {
//   if (!invoiceData) return;

//   const content =
//     document.getElementById("invoice-print-area").innerHTML;

//   const iframe = document.createElement("iframe");
//   iframe.style.position = "fixed";
//   iframe.style.right = "0";
//   iframe.style.bottom = "0";
//   iframe.style.width = "0";
//   iframe.style.height = "0";
//   iframe.style.border = "0";

//   document.body.appendChild(iframe);

//   const doc =
//     iframe.contentWindow.document ||
//     iframe.contentDocument;

//   doc.open();
//   doc.write(`
//     <html>
//       <head>
//         <title>Print Invoice</title>

//         <style>
//           body{
//             margin:0;
//             padding:20px;
//             font-family:"Times New Roman", serif;
//             font-size:12px;
//             color:#000;
//           }

//           table{
//             width:100%;
//             border-collapse:collapse;
//             table-layout:fixed;
//           }

//           table, td, th{
//             border:1px solid #000;
//           }

//           td, th{
//             padding:4px;
//             vertical-align:top;
//           }

//           span{
//             color:red !important;
//             font-weight:bold;
//           }

//           @page{
//             size:A4 portrait;
//             margin:10mm;
//           }
//         </style>
//       </head>

//       <body>
//         ${content}
//       </body>
//     </html>
//   `);

//   doc.close();

//   setTimeout(() => {
//     iframe.contentWindow.focus();
//     iframe.contentWindow.print();

//     setTimeout(() => {
//       document.body.removeChild(iframe);
//     }, 1000);
//   }, 500);
// };


const handlePrint = () => {
  if (!invoiceData) return;

  const doc = generateInvoice(invoiceData);

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  const printWindow = window.open(pdfUrl);

  if (printWindow) {
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  }
};
  const loadCertificatePreview = async (values) => {
    try {
      setLoading(true);
      const deviceData = { device_id: values.device_id };
      const response = await TaggingService.vahanVerificationApi(deviceData);

      const device = response?.data?.Skytrack_data?.device || response?.Skytrack_data?.device;
      const owner = response?.data?.Skytrack_data?.vehicle_owner?.users?.[0] || response?.Skytrack_data?.vehicle_owner?.users?.[0];
      const vehicle = response?.data?.Skytrack_data || response?.Skytrack_data;
      const rawVahanData = response?.data?.vahan_data ?? response?.vahan_data;

      let vahanPayload = rawVahanData;
      if (rawVahanData && typeof rawVahanData === "string") {
        try {
          vahanPayload = JSON.parse(rawVahanData);
        } catch (e) {
          console.error("Failed to parse vahan_data string", e);
        }
      }

      const vahanData = vahanPayload?.VltdDetailsDobj || response?.data?.VltdDetailsDobj || response?.VltdDetailsDobj;

      setCertificateData({
        taggingActivationDate: vahanData?.dateOfRegistration || "",
        vehicleOwnerName: vahanData?.ownerName || owner?.name || "",
        vehicleRegNo: vehicle?.vehicle_reg_no || vahanData?.regnNo || "",
        engineNo: vehicle?.engine_no || vahanData?.engineNo || "",
        chassisNo: vehicle?.chassis_no || vahanData?.chassisNo || "",
        vehicleModel: vehicle?.vehicle_model || vahanData?.modelName || "",
        vehicleCategory: vehicle?.category || vahanData?.vehClass || "",
        vltdMake: vehicle?.vehicle_make || vahanData?.makerName || "",
        vltdModel: device?.model || vahanData?.deviceSerialno || "",
        vltdImei: device?.imei || vahanData?.imeiNo || "",
        esimIccid: device?.iccid || vahanData?.iccId || "",
        esimIccid2: formatICCID(device?.iccid2),
        esimValidity: device?.esim_validity || "",
      });
    } catch (error) {
      console.error("Error loading certificate preview", error?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePrintCertificate = () => {
    if (!certificateData) {
      alert("Please view the certificate first by clicking 'View Certificate'.");
      return;
    }
    const printWindow = window.open("", "_blank", "width=800,height=1000");
    if (!printWindow) return;

    const fields = [
      { label: "VLTD Tagging & Activation Date", value: certificateData.taggingActivationDate },
      { label: "Vehicle Owner Name", value: certificateData.vehicleOwnerName },
      { label: "Vehicle Registration Number", value: certificateData.vehicleRegNo },
      { label: "Engine Number", value: certificateData.engineNo },
      { label: "Chassis Number", value: certificateData.chassisNo },
      { label: "Vehicle Model", value: certificateData.vehicleModel },
      { label: "Vehicle Category", value: certificateData.vehicleCategory },
      { label: "VLTD Make", value: certificateData.vltdMake },
      { label: "VLTD Model", value: certificateData.vltdModel },
      { label: "VLTD IMEI Number", value: certificateData.vltdImei },
      { label: "eSIM ICCID Number", value: certificateData.esimIccid },
      { label: "eSIM Validity", value: certificateData.esimValidity },
    ];

    const fieldRows = fields.map(f => `<div style="margin-bottom:8px;font-size:14px;">${f.label}: ${f.value || "__________"}</div>`).join("");

    const logoUrl = window.location.origin + mapwalLogo;

    const printHtml = `
<!DOCTYPE html>
<html>
<head>
  <title>Certificate</title>
  <style>
    @media print {
      @page { margin: 20px; }
      body { 
        font-family: "Times New Roman", Times, serif; 
        padding: 20px; 
        background-image: url('${logoUrl}');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
    body { 
      font-family: "Times New Roman", Times, serif; 
      padding: 40px; 
      background-image: url('${logoUrl}');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    .certificate-container { max-width: 800px; margin: 0 auto; }
    .certificate-title { text-align: center; font-size: 24px; font-weight: bold; margin-bottom: 8px; }
    .certificate-subtitle { text-align: center; font-size: 18px; font-weight: bold; margin-bottom: 32px; }
    .certificate-field { margin-bottom: 8px; font-size: 14px; }
    .certificate-note { margin-top: 32px; font-size: 12px; }
    .certificate-footer { margin-top: 40px; text-align: center; font-size: 12px; }
  </style>
</head>
<body>
  <div class="certificate-container">
    <h2 class="certificate-title">ASSAM STATE VLTD BACKEND</h2>
    <h3 class="certificate-subtitle">VLTD TAGGING &amp; ACTIVATION CERTIFICATE</h3>
    <div>
      ${fieldRows}
      <div class="certificate-note" style="margin-top:32px;">Note:</div>
      <div class="certificate-note" style="margin-top:8px;">
        This certificate is system-generated from the SkyTron platform and does not require any physical signature or stamp.
      </div>
      <div class="certificate-footer" style="margin-top:40px;text-align:center;">**********************</div>
    </div>
  </div>
</body>
</html>`;

    printWindow.document.open();
    printWindow.document.write(printHtml);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  const numberToWords = (num) => {
  const ones = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const convert = (n) => {
    if (n < 20) return ones[n];

    if (n < 100)
      return `${tens[Math.floor(n / 10)]} ${ones[n % 10]}`.trim();

    if (n < 1000)
      return `${ones[Math.floor(n / 100)]} Hundred ${convert(n % 100)}`.trim();

    if (n < 100000)
      return `${convert(Math.floor(n / 1000))} Thousand ${convert(n % 1000)}`.trim();

    if (n < 10000000)
      return `${convert(Math.floor(n / 100000))} Lakh ${convert(n % 100000)}`.trim();

    return n;
  };

  return convert(num);
};

  return (
    <MainCard title="Download Invoice">
      {isFormLoaded && (
        <Formik
          initialValues={uploadReceiptInitials}
          validationSchema={validationSchema}
          onSubmit={() => { }}
          enableReinitialize
        >
          {(formik) => (
            <form onSubmit={(e) => e.preventDefault()}>
              <Grid container spacing={2} className="form-controller">
                {Object.keys(updatedFormFields).map((field) => (
                  <Grid key={field} item md={4} sm={12} xs={12}>
                    <FormField
                      fieldConfig={updatedFormFields[field]}
                      formik={formik}
                      handleFileChange={handleFileChange}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} style={{ marginTop: "20px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <Button
                    type="button"
                    variant="outlined"
                    color="primary"
                    startIcon={<Visibility />}
                    disabled={loading || !formik.values.device_id}
                    onClick={() => loadInvoice(formik.values)}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                  >
                    View Invoice
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    startIcon={<Print />}
                    disabled={loading || !invoiceData}
                    onClick={handlePrint}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                  >
                    Print Invoice
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    startIcon={<Download />}
                    disabled={loading || !invoiceData}
                    onClick={handleDownloadPdf}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                  >
                    Download Invoice
                    {/* {t('common.download', { defaultValue: 'Download Invoice' })} */}
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      )}
      {invoiceData && (
        // <Grid container justifyContent="center" style={{ marginTop: "32px" }}>
        //   <Grid item xs={12} md={11} lg={9}>
        //     <Paper
        //       elevation={8}
        //       sx={{
        //         background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        //         borderRadius: 4,
        //         overflow: 'hidden',
        //         position: 'relative',
        //         '&::before': {
        //           content: '""',
        //           position: 'absolute',
        //           top: 0,
        //           left: 0,
        //           right: 0,
        //           height: '8px',
        //           background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 50%, #42a5f5 100%)',
        //         }
        //       }}
        //     >
        //       <Box sx={{ p: 4, position: 'relative' }}>
        //         {/* Header Section */}
        //         <Box sx={{ textAlign: 'center', mb: 4 }}>
        //           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
        //             <CheckCircle sx={{ color: '#1976d2', fontSize: 32, mr: 1 }} />
        //             <Typography variant="h4" sx={{
        //               fontWeight: 700,
        //               color: '#1565c0',
        //               letterSpacing: 1,
        //               textTransform: 'uppercase'
        //             }}>
        //               Assam State VLTD Backend
        //             </Typography>
        //           </Box>
        //           <Divider sx={{ mb: 2, bgcolor: '#1976d2' }} />
        //           <Typography variant="h5" sx={{
        //             fontWeight: 600,
        //             color: '#424242',
        //             letterSpacing: 0.5
        //           }}>
        //             VLTD Tagging & Activation Certificate
        //           </Typography>
        //           <Chip
        //             label="Official Document"
        //             color="primary"
        //             size="small"
        //             sx={{ mt: 1 }}
        //           />
        //         </Box>

        //         {/* Certificate Content */}
        //         <Box sx={{
        //           backgroundColor: 'rgba(255, 255, 255, 0.9)',
        //           borderRadius: 3,
        //           p: 3,
        //           mb: 3,
        //           boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        //         }}>
        //           <Grid container spacing={3}>
        //             <Grid item xs={12} md={6}>
        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <CalendarToday sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     TAGGING & ACTIVATION DATE
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.taggingActivationDate || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Person sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VEHICLE OWNER NAME
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vehicleOwnerName || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <LocalShipping sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VEHICLE REGISTRATION NUMBER
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vehicleRegNo || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Settings sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     ENGINE NUMBER
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.engineNo || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <LocalShipping sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     CHASSIS NUMBER
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.chassisNo || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Settings sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VEHICLE MODEL
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vehicleModel || "__________"}
        //                 </Typography>
        //               </Box>
        //             </Grid>

        //             <Grid item xs={12} md={6}>
        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <LocalShipping sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VEHICLE CATEGORY
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vehicleCategory || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Settings sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VLTD MAKE
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vltdMake || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Settings sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VLTD MODEL
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vltdModel || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Settings sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     VLTD IMEI NUMBER
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.vltdImei || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Phone sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     ESIM ICCID NUMBER
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.esimIccid || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <Phone sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     ESIM ICCID NUMBER 2
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.esimIccid2 || "__________"}
        //                 </Typography>
        //               </Box>

        //               <Box sx={{ mb: 3 }}>
        //                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        //                   <CalendarToday sx={{ color: '#1976d2', fontSize: 20, mr: 1 }} />
        //                   <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#666' }}>
        //                     ESIM VALIDITY
        //                   </Typography>
        //                 </Box>
        //                 <Typography variant="body1" sx={{ fontWeight: 500, ml: 3 }}>
        //                   {certificateData.esimValidity || "__________"}
        //                 </Typography>
        //               </Box>
        //             </Grid>
        //           </Grid>
        //         </Box>

        //         {/* Footer Section */}
        //         <Box sx={{
        //           backgroundColor: 'rgba(25, 118, 210, 0.08)',
        //           borderRadius: 2,
        //           p: 2,
        //           textAlign: 'center'
        //         }}>
        //           <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2', mb: 1 }}>
        //             Note:
        //           </Typography>
        //           <Typography variant="body2" sx={{ color: '#666', fontSize: '0.875rem' }}>
        //             This certificate is system-generated from the SkyTron platform and does not require any physical signature or stamp.
        //           </Typography>
        //           <Box sx={{ mt: 2, mb: 1 }}>
        //             <Typography variant="body2" sx={{
        //               letterSpacing: 2,
        //               color: '#1976d2',
        //               fontWeight: 600
        //             }}>
        //               **********************
        //             </Typography>
        //           </Box>
        //         </Box>
        //       </Box>
        //     </Paper>
        //   </Grid>
        // </Grid>
        <Paper
          elevation={4}
          id="invoice-print-area"
          sx={{
            mt: 4,
            p: 3,
            border: "1px solid #000",
            fontFamily: "Times New Roman",
            fontSize: "14px",
            color: "#000"
          }}
        >
         <table
  width="100%"
  border="1"
  cellPadding="8"
  cellSpacing="0"
  style={{
    borderCollapse: "collapse",
    marginTop: "20px"
  }}
>
  <tbody>

    {/* TITLE */}
    <tr>
      <td colSpan="8" align="center">
        <h2>Tax Invoice</h2>
      </td>
    </tr>

    {/* SELLER + INVOICE DETAILS */}
    <tr>
      <td rowSpan="3" colSpan="4" valign="top">
        <b>Seller</b>
        <br />
        {invoiceData.dealer || ""}
        <br />
        Address: {invoiceData.dealer_address || ""}
        <br />
        GSTIN: {invoiceData.dealer_gstn || ""}
        <br />
        State: {invoiceData.dealer_state || ""}
      </td>

      <td colSpan="2">
        <b>Invoice No.</b>
        <br />
        {invoiceData.bill_no || ""}
      </td>

      <td colSpan="2">
        <b>Date</b>
        <br />
        {invoiceData.invoice_date || ""}
      </td>
    </tr>

    <tr>
      <td colSpan="2">
        <b>Supplier Reference</b>
        <br />
        {invoiceData.device_imei_no || ""}
      </td>

      <td colSpan="2">
        <b>Chassis No</b>
        <br />
        {invoiceData.chassis_no || ""}
      </td>
    </tr>

    <tr>
      <td colSpan="2">
        <b>Registration No</b>
        <br />
        {invoiceData.vehicle_reg_no || ""}
      </td>

      <td colSpan="2">
        <b>Quantity</b>
        <br />
        1 Pcs
      </td>
    </tr>

    {/* BUYER */}
    <tr>
      <td colSpan="4" valign="top">
  <b>Buyer</b>
  <br />

  <b>{invoiceData.customer || ""}</b>
  <br />

  Address : {invoiceData.customer_address || ""}
  <br />

  State : {invoiceData.owner_state || ""}
  <br />

  GSTIN : {invoiceData.customer_gstin || ""}
  <br />

  Mobile No : {invoiceData.owner_mobile_no || ""}
</td>

      <td colSpan="2"></td>
      <td colSpan="2"></td>
    </tr>

    {/* PRODUCT HEADER */}
    <tr>
      <th>SL</th>
      <th colSpan="3">Description of Goods</th>
      <th>HSN</th>
      <th>GST</th>
      <th>Qty</th>
      <th>Amount</th>
    </tr>

    {/* PRODUCT */}
    <tr style={{ height: "140px" }}>
      <td>1</td>

      <td colSpan="3" valign="top">
        <b>Vehicle Location Tracking Device</b>

        <br />
        <br />

        Make : Mapwala

<br />

Model : Mapwala T600

        <br />
        <br />

        <b>IMEI : {invoiceData.device_imei_no || ""}</b>
      </td>

      <td>852691</td>

      <td>18%</td>

      <td>1 Pcs</td>

      <td>{invoiceData.net_amount || ""}</td>
    </tr>

    {/* GST */}
    <tr>
      <td></td>
      <td colSpan="3">Discount</td>
      <td colSpan="3"></td>
      <td>0.00</td>
    </tr>

    {Number(invoiceData?.dealer_state_id) !==
 Number(invoiceData?.owner_state_id) ? (
  <tr>
    <td></td>
    <td colSpan="3"></td>
    <td>IGST</td>
    <td>18%</td>
    <td></td>
    <td>{invoiceData.igst_18_percent || ""}</td>
  </tr>
) : (
  <>
    <tr>
      <td></td>
      <td colSpan="3"></td>
      <td>CGST</td>
      <td>9%</td>
      <td></td>
      <td>{invoiceData.cgst_9_percent || ""}</td>
    </tr>

    <tr>
      <td></td>
      <td colSpan="3"></td>
      <td>SGST</td>
      <td>9%</td>
      <td></td>
      <td>{invoiceData.sgst_9_percent || ""}</td>
    </tr>
  </>
)}

    {/* TOTAL */}
    <tr>
      <td colSpan="6" align="center">
        <b>Total</b>
      </td>

      <td>1 Pcs</td>

      <td>
        <b>{invoiceData.gross_amount || ""}</b>
      </td>
    </tr>

    {/* AMOUNT WORDS */}
    <tr>
  <td colSpan="8">
    Amount Chargeable (in words)
    <br />
    <b>
      {numberToWords(
        Math.round(Number(invoiceData?.gross_amount || 0))
      )} Only
    </b>
  </td>
</tr>

    {/* BANK */}
    <tr>
      <td colSpan="8">
        <b>Seller Bank Details</b>

        <br />
        Name : {
    invoiceData?.account_name ||
    process.env.REACT_APP_ACCOUNT_NAME ||
    ""
  }

        <br />
        A/c No : {
    invoiceData?.account_number ||
    process.env.REACT_APP_ACCOUNT_NUMBER ||
    ""
  }

        <br />
        Bank : {
    invoiceData?.bank_name ||
    process.env.REACT_APP_BANK_NAME ||
    ""
  }

        <br />
        Branch : {
    invoiceData?.branch ||
    process.env.REACT_APP_BRANCH ||
    ""
  }

        <br />
        IFSC : {
    invoiceData?.ifsc_code ||
    process.env.REACT_APP_IFSC_CODE ||
    ""
  }
      </td>
    </tr>

    {/* DECLARATION */}
    <tr>
  <td colSpan="5" valign="top" style={{ height: "90px" }}>
    <b>Declaration:</b>
    <br />
    We declare that this invoice shows the actual
    price of the goods described and particulars are
    correct.
  </td>

  <td
    colSpan="3"
    align="center"
    valign="bottom"
    style={{ height: "90px" }}
  >
    <b>Authorised Signatory</b>
  </td>
</tr>

<tr>
  <td
    colSpan="8"
    align="center"
    style={{
      fontStyle: "italic",
      fontSize: "18px",
      padding: "15px"
    }}
  >
    This is a Computer Generated Invoice
  </td>
</tr>

  </tbody>
</table>
        </Paper>

      )}
    </MainCard>
  );
};

export default UploadReceipt;
